import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

interface ButtonProps {
    onClick: () => void;
    icon?: React.ReactNode;
    children: React.ReactNode;
    size?: 'small' | 'medium';
    disabled?: boolean;
}
const CustomButton = ({
    onClick,
    icon,
    children,
    size = 'medium',
    disabled = false,
}: ButtonProps) => {
    const classes = useStyles({});
    return (
        <Button
            startIcon={icon}
            className={size === 'medium' ? classes.medium : classes.small}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </Button>
    );
};

const useStyles = makeStyles((theme) => ({
    medium: {
        display: 'inline-flex',
        minWidth: 0,
        height: '44px',
        padding: '0 24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        borderRadius: 30,
        backgroundColor: theme.palette.primary.main,
        color: '#FFF',
        fontFamily: 'Noto Sans',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '1',
        letterSpacing: '-0.324px',
        textTransform: 'none',
        transition: 'background 0.3s ease',
        whiteSpace: 'nowrap',
        width: 'auto',
        overflow: 'hidden',
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            color: '#FFF',
        },
        '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
            color: theme.palette.action.disabled,
            cursor: 'not-allowed',
        },
    },
    small: {
        display: 'inline-flex',
        minWidth: 0,
        height: '30px',
        padding: '0 12px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        borderRadius: 16,
        backgroundColor: theme.palette.primary.main,
        color: '#FFF',
        fontFamily: 'Noto Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '1',
        letterSpacing: '-0.324px',
        textTransform: 'none',
        transition: 'background 0.3s ease',
        whiteSpace: 'nowrap',
        width: 'auto',
        overflow: 'hidden',
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            color: '#FFF',
        },
        '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
            color: theme.palette.action.disabled,
            cursor: 'not-allowed',
        },
    },
}));

export default CustomButton;
